import { Invite, InvitePage } from '@mkp/account-membership/models';
import { createActionGroup, props } from '@ngrx/store';

export const invitedUsersActions = createActionGroup({
  source: 'Invited Users',
  events: {
    'Delete Invite': props<{ inviteId: string; page: InvitePage }>(),
    'Resend Invite': props<{ invite: Invite; page: InvitePage }>(),
  },
});
